import { FaRegFilePdf } from "react-icons/fa6";

import { getUploadUrl } from "src/Common/common";

const AttachmentDeleteModal = ({ shown, attachment, onCancel, onConfirm, isDeleting = false }) => {
  if (!shown || !attachment) return null;

  const isPdf = (attachment?.fileName || "").toLowerCase().endsWith(".pdf");

  return (
    <div className="fixed inset-0 z-[11000] bg-black/50 flex items-center justify-center p-4" onClick={onCancel}>
      <div
        className="w-full max-w-[340px] bg-white border border-borderColor rounded-[10px] p-3"
        onClick={(event) => event.stopPropagation()}
      >
        <p className="text-center font-OpenSansRegular text-[14px] font-[700] text-titleColor mb-3">Delete Attachment</p>

        <div className="w-full h-[200px] rounded-[6px] overflow-hidden border border-borderColor bg-[#eceff4]">
          {isPdf ? (
            <div className="w-full h-full bg-[#f2f4f7] flex flex-col items-center justify-center text-subTitleColor gap-2">
              <FaRegFilePdf size={42} />
              <span className="font-OpenSansRegular text-[12px] font-[600]">PDF</span>
            </div>
          ) : (
            <img src={getUploadUrl(attachment.fileName)} alt={attachment.displayName || "Attachment"} className="w-full h-full object-cover" />
          )}
        </div>

        <p className="text-center font-OpenSansRegular text-[14px] text-subTitleColor mt-4 mb-4">Are you sure you want to delete this file?</p>

        <div className="grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="h-[36px] border border-[#C4CAD8] rounded-[7px] font-OpenSansRegular text-[14px] font-[700] text-[#404A6E]"
          >
            CANCEL
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className={`h-[36px] rounded-[7px] font-OpenSansRegular text-[14px] font-[700] text-white ${isDeleting ? "bg-[#E62B2B]/70 cursor-not-allowed" : "bg-[#E62B2B]"}`}
          >
            {isDeleting ? "DELETING..." : "DELETE"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttachmentDeleteModal;
